export const toSafeNumber = (value: unknown): number => {
  if (value === null || value === undefined || value === '') return 0;

  const num = Number(value);
  return Number.isFinite(num) ? num : 0;
};

export const formatIntegerNumber = (value: unknown): string => {
  return Math.round(toSafeNumber(value)).toLocaleString('vi-VN', {
    maximumFractionDigits: 0,
  });
};
